import * as React from "react";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AppTooltip from "../common/AppTooltip";

export default function PermissionLevelTooltip({
  placement = "right",
  iconSize = "small",
  buttonSize = "small",
  ariaLabel = "Permission level help",
  permissionLevelDefinitions =[]
}) {
    return (
        <AppTooltip
            placement={placement}
            title={
                <Box sx={{ maxWidth: 300 }}>
                    {
                        permissionLevelDefinitions.map((l) => (
                            <Box 
                                key={l.id}
                            >
                                <Typography 
                                     
                                    variant="subtitle2" 
                                    // sx={{ lineHeight: 1.5, mb: 0.5 }}
                                >
                                    <strong>{l.label}</strong> :  
                                </Typography>
                                <Typography variant="body2">
                                    {l.description}
                                </Typography>
                            </Box>
                        ))
                    }
                </Box>
            }
        >
            <IconButton size={buttonSize} aria-label={ariaLabel}>
                <InfoOutlinedIcon fontSize={iconSize}/>
            </IconButton>

        </AppTooltip>
    )
}